import React from "react";
import Header, { Footer } from "../HomePage/header";
import "./privacy.css";

const PrivacyPolicy = () => {
  return (
    <>
    <Header/>
    <div className="privacy-container">

      {/* Top Blue Header */}
      <div className="privacy-header">
        <div className="privacy-header-content">
          <div>
            <h2>A privacy resource for our customers.</h2>
            <p>
              Below, you can view our Privacy Policy, read about our privacy
              practices and learn how you can control and protect your personal
              information online.
            </p>
          </div>
          <img
            src="/images/privacy-banner.jpg"
            alt="privacy"
            className="privacy-header-img"
          />
        </div>
      </div>

      {/* Main Section */}
      <div className="privacy-body">

        {/* Left Sidebar */}
        <div className="privacy-left">

          <div className="privacy-box">
            <h4>Protecting privacy on your devices.</h4>
            <p>
              Learn how Sulav Sewa helps protect your personal data across your
              devices and services.
            </p>
          </div>

          <div className="privacy-box">
            <h4>Learn how to protect your privacy.</h4>
            <p>
              Understand best practices for keeping your data safe while using
              Sulav Sewa services.
            </p>
          </div>

          <div className="privacy-box highlight">
            <h4>Consumer data privacy laws</h4>
            <p>
              Sulav Sewa complies with applicable privacy laws to ensure your
              data is protected and handled responsibly.
            </p>
          </div>

          <div className="privacy-box">
            <h4>Have any questions?</h4>
            <p>Email: support@sulavsewa.com</p>
            <p>Phone: +9779851403714</p>
          </div>

        </div>

        {/* Right Content */}
        <div className="privacy-right">

          <div className="privacy-main-box">
            <h3>Our Privacy Policy - Simplified.</h3>

            <p>
              This privacy policy explains how Sulav Sewa collects, uses, and
              protects your personal information when you use our services.
            </p>

            <h4>What data we collect</h4>
            <ul>
              <li>Personal information (name, email, phone)</li>
              <li>Order and transaction details</li>
              <li>Device and usage information</li>
            </ul>

            <h4>What we do with the information</h4>
            <ul>
              <li>Provide and improve our services</li>
              <li>Process transactions</li>
              <li>Enhance user experience</li>
            </ul>

            <h4>Security</h4>
            <p>
              We take appropriate measures to protect your personal data from
              unauthorized access or disclosure.
            </p>

            <h4>How we use cookies</h4>
            <p>
              Cookies help us improve your experience by remembering preferences
              and analyzing usage patterns.
            </p>

            <h4>Links to other websites</h4>
            <p>
              Our platform may contain links to external sites. We are not
              responsible for their privacy practices.
            </p>

            <h4>List of Cookies we collect</h4>

            <table>
              <thead>
                <tr>
                  <th>Cookie</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>CART</td>
                  <td>Stores items in your shopping cart</td>
                </tr>
                <tr>
                  <td>USER</td>
                  <td>Stores logged-in user details</td>
                </tr>
                <tr>
                  <td>SESSION</td>
                  <td>Maintains session state</td>
                </tr>
                <tr>
                    <td>CURRENCY</td>
                    <td>Your preferred currency.</td>
                </tr>
                <tr>
                    <td>CUSTOMER</td>
                    <td>An encrypted version of your customer id with the store.</td>
                </tr>
                <tr>
                    <td>FRONTEND</td>
                    <td>Your session ID on the server.</td>
                </tr>
                <tr>
                    <td>CUSTOMER INFO</td>
                    <td>An encrypted version of the customer group you belong to.</td>
                </tr>
                <tr>
                    <td>CUSTOMER_AUTH</td>
                    <td>An indicator if you are currently logged into the store.</td>
                </tr>
              </tbody>
            </table>

          </div>

        </div>

      </div>

    </div>
    <Footer/>
    </>
  );
};

export default PrivacyPolicy;